import useAuth from 'src/contexts/JWTAuthContext';

export default useAuth;
